import { render, staticRenderFns } from "./ProdutorBasesDialog.vue?vue&type=template&id=3eaa3846&scoped=true&lang=pug"
import script from "./ProdutorBasesDialog.vue?vue&type=script&lang=js"
export * from "./ProdutorBasesDialog.vue?vue&type=script&lang=js"
import style0 from "./ProdutorBasesDialog.vue?vue&type=style&index=0&id=3eaa3846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaa3846",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VDialog,VIcon})
